"use strict";
module.exports = {
    CUSTOMER_SUB_UNIT_UPDATED: 'Kund uppdaterad',
    CUSTOMER_SUB_UNIT_DELIVERY_DETAILS_CHANGED: 'Kundens leveransuppgifter uppdaterade',
    CUSTOMER_SUB_UNIT_INVOICE_DETAILS_CHANGED: 'Kundens fakturauppgifter uppdaterade',
    CUSTOMER_SUB_UNIT_CONTACTS_UPDATED: 'Kundkontakter uppdaterad',
    CUSTOMER_SUB_UNIT_CREATED: 'Kund skapad',
    CUSTOMER_SUB_UNIT_APPROVED: 'Kund godkänd',
    CUSTOMER_SUB_UNIT_BLOCKED: 'Kund blockerad från köp',
    CUSTOMER_SUB_UNIT_MERGED: 'Kund ihopslagen',
    CUSTOMER_SUB_UNIT_MARKED_AS_DUPLICATE: 'Kund markerad som dubblett',
    CUSTOMER_SUB_UNIT_UNBLOCKED: 'Kund har fått tillbaka rätten att beställa',
    CUSTOMER_SUB_UNIT_INVOICE_INFO_CHANGE_REQUESTED: 'Begärts ändring av kunds faktureringsuppgifter',
    CUSTOMER_SUB_UNIT_SET_EXTERNAL_CUSTOMER_NUMBER: 'Externt kundnummer knutet till kunden',
    CUSTOMER_SUB_UNIT_CONNECTED_TO_QVANTI: 'Kund kopplad till Qvanti',
    CUSTOMER_SUB_UNIT_DISCONNECTED_FROM_QVANTI: 'Kund bortkopplad från Qvanti',
    CUSTOMER_SUB_UNIT_ALCOHOL_LICENSE_APPROVED: 'Kundens alkoholtillstånd godkänt',
    CUSTOMER_SUB_UNIT_ALCOHOL_LICENSE_REVOKED: 'Kundens alkoholtillstånd återkallat',
    BRAND_UPDATED: 'Varumärket uppdaterat',
    BRAND_CREATED: 'Varumärket skapat',
    BRAND_ACTIVATED: 'Varumärket aktiverat',
    BRAND_DEACTIVATED: 'Varumärket inaktiverad',
    SUPPLIER_PUBLISHED_ON_QVANTI: 'Leverantör publicerad till Qvanti',
    SUPPLIER_UNPUBLISHED_ON_QVANTI: 'Leverantör avpublicerad hos Qvanti',
    SUPPLIER_UPDATED: 'Leverantör uppdaterad',
    SUPPLIER_CREATED: 'Leverantör skapad',
    SUPPLIER_METADATA_CHANGED: 'Leverantörens metadata ändrad',
    ARTICLE_UPDATED: 'Artikel uppdaterad',
    ARTICLE_CREATED: 'Artikel skapad',
    ARTICLE_ACTIVATED: 'Artikel aktiverad',
    ARTICLE_DEACTIVATED: 'Artikel inaktiverad',
    ARTICLE_CAMPAIGN_STARTED: 'Priskampanj startad',
    ARTICLE_CAMPAIGN_ENDED: 'Priskampanj avslutad',
    ARTICLE_PUBLISHED_ON_WHITELABEL: 'Artikel publicerad på whitelabel',
    ARTICLE_PUBLISHED_ON_OUR_STORE: 'Artikel publicerad på Flaivy.com',
    ARTICLE_PUBLISHED_ON_PRO: 'Artikel publicerad på Qvanti',
    ARTICLE_PUBLISHED_ON_STOCKFILLER: 'Artikel publicerad hos Stockfiller',
    ARTICLE_UNPUBLISHED_ON_WHITELABEL: 'Artikel avpublicerad på whitelabel',
    ARTICLE_UNPUBLISHED_ON_OUR_STORE: 'Artikel avpublicerad på Flaivy.com',
    ARTICLE_UNPUBLISHED_ON_PRO: 'Artikel avpublicerad på Qvanti',
    ARTICLE_UNPUBLISHED_ON_STOCKFILLER: 'Artikel avpublicerad hos Stockfiller',
    ARTICLE_STOCKCHANGE: 'Artikelsaldoändring',
    ARTICLE_BATCH_BLOCKED: 'Parti på artikel spärrat',
    ARTICLE_BATCH_UNBLOCKED: 'Parti på artikel upplåst',
    ARTICLE_QUANTITY_IN_EXACTA_STOCK_CHANGED: 'Artikelsaldoändring Systembolaget',
    ARTICLE_CUSTOMER_SUB_UNIT_SPECIFIC_ARTICLE_CREATED: 'Kundspecifik artikel skapad',
    ARTICLE_CUSTOMER_SUB_UNIT_SPECIFIC_ARTICLE_UPDATED: 'Kundspecifik artikel uppdaterad',
    ARTICLE_METADATA_CHANGED: 'Artikelns metadata ändrad',
    ARTICLE_LABEL_ADDED: 'Etikett tillagd',
    ARTICLE_LABEL_REMOVED: 'Etikett borttagen',
    ARTICLE_QUANTITY_IN_DLP_STOCK_CHANGED: 'Artikelsaldoändring DLP',
    ORDER_UPDATED: 'Order uppdaterad',
    ORDER_CREATED: 'Order skapad',
    ORDER_CANCELLED: 'Order makulerad',
    ORDER_INVOICED: 'Order fakturerad',
    ORDER_CHANGED_DURING_DELIVERY: 'Order ändrats av lagret',
    ORDER_DELIVERED: 'Order levererad',
    ORDER_READY_FOR_SHIPPING: 'Order packad',
    ORDER_PLACED: 'Order lagd',
    ORDER_APPROVED: 'Order godkänd',
    ORDER_APPROVED_BY_DROPSHIPSUPPLIER: 'Order godkänd av dropshipleverantör',
    ORDER_WAITING_FOR_RESTOCK: 'Order väntar på inleverans',
    ORDER_WAITING_FOR_ADMIN: 'Order väntar på administrativ hantering',
    ORDER_WAREHOUSE_PROCESSING_STARTED: 'Plockning av order påbörjad',
    ORDER_EXTENDED: 'Order kompletterad',
    ORDER_SENT: 'Order skickad till kund',
    ORDER_DELIVERY_DATE_CHANGED: 'Leveransdatum för order ändrad',
    ORDER_ADVANCE_PAYMENT_RECEIVED: 'Förskottsbetalning mottagen',
    ORDER_MERGED: 'Order sammanslagen',
    ORDER_DELIVERY_DEVIATION: 'Leveransavvikelse',
    ORDER_OFC_CHANGED: 'Leveranslager ändrat',
    ORDER_CONNECTED_TO_SUPPLIER_CUSTOMER: 'Order kopplad till kund',
    ORDER_METADATA_CHANGED: 'Order metadata ändrad',
    SUPPLIER_SALES_REPORT_CREATED: 'SUPPLIER_SALES_REPORT_CREATED',
    SUPPLIER_SALES_REPORT_UPDATED: 'SUPPLIER_SALES_REPORT_UPDATED',
    SUPPLIER_SALES_REPORT_SENT_TO_SUPPLIER: 'SUPPLIER_SALES_REPORT_SENT_TO_SUPPLIER',
    PURCHASE_ORDER_SENT_TO_SUPPLIER: 'Inleveransorder skickad till leverantör',
    PURCHASE_ORDER_DELIVERY_RECEIVED: 'Inleveransordern har ankommit',
    PURCHASE_ORDER_DELIVERY_PROCESSED: 'Inleveransorder inlevererad.',
    PURCHASE_ORDER_SENT: 'Inleverans skickad från leverantör',
    PURCHASE_ORDER_EMCS_DOWNLOADED: 'Inleverans skickad från leverantör',
    PURCHASE_ORDER_REQUESTED: 'Inleveransorder skickad till granskning',
    PURCHASE_ORDER_CANCELLED: 'Inleveransorder makulerad',
    PURCHASE_ORDER_UPDATED: 'Inleveransorder uppdaterad',
    PURCHASE_ORDER_CREATED: 'Inleveransorder skapad',
    INVOICE_UPDATED: 'Faktura uppdaterad',
    INVOICE_CREATED: 'Faktura skapad',
    PRICE_LIST_UPDATED: 'Prislista uppdaterad',
    PRICE_LIST_CREATED: 'Prislista skapad',
    PRICE_LIST_ACTIVATED: 'Prislista aktiverad',
    PRICE_LIST_DEACTIVATED: 'Prislista inaktiverad',
    CAMPAIGN_UPDATED: 'Kampanj uppdaterad',
    CAMPAIGN_CREATED: 'Kampanj skapad',
    PURCHASE_LIST_UPDATED: 'Favoritlista uppdaterad',
    PURCHASE_LIST_CREATED: 'Favoritlista skapad',
    PURCHASE_LIST_ACTIVATED: 'Favoritlista aktiverad',
    PURCHASE_LIST_DEACTIVATED: 'Favoritlista inaktiverad',
    COMPLAINT_UPDATED: 'Reklamation uppdaterad',
    COMPLAINT_CREATED: 'Reklamation skapad',
    COMPLAINT_CANCELLED: 'Reklamation makulerad',
    COMPLAINT_PLACED: 'Reklamation lagd',
    COMPLAINT_REVIEW_STARTED: 'Reklamation granskning startad',
    COMPLAINT_RESOLVED: 'Reklamation granskad',
    ORDER_FULLFILLMENT_CENTER_UPDATED: 'Lagerställe uppdaterat',
    ORDER_FULLFILLMENT_CENTER_CREATED: 'Lagerställe skapat',
    ORDER_FULLFILLMENT_CENTER_ACTIVATED: 'Lagerställe aktiverat',
    ORDER_FULLFILLMENT_CENTER_DEACTIVATED: 'Lagerställe inaktiverad',
    SUPPLIER_CUSTOMER_IN_OMS_SERVICE_CREATED: 'oms supplier-customer created',
    SUPPLIER_CUSTOMER_IN_OMS_SERVICE_UPDATED: 'oms supplier-customer updated',
    ORGANIZATION_IN_OMS_SERVICE_UPDATED: 'ORGANIZATION_IN_OMS_SERVICE_UPDATED',
    ORGANIZATION_IN_OMS_SERVICE_CREATED: 'ORGANIZATION_IN_OMS_SERVICE_CREATED',
    LABEL_UPDATED: 'Etikett uppdaterat',
    LABEL_CREATED: 'Etikett skapat',
    LABEL_ACTIVATED: 'Etikett aktiverat',
    LABEL_DEACTIVATED: 'Etikett inaktiverad',
};
